export const LOCATIONS: { [key: string]: string[] } = {
  america: ['DFW', 'HAV', 'JFK', 'LAX', 'MIA', 'NYC', 'ORD', 'POP', 'PVR', 'SEA', 'SFO', 'YTO', 'YYZ'],
  asia: [
    'BJS',
    'BKK',
    'BOM',
    'CAN',
    'CKG',
    'DEL',
    'DOH',
    'DXB',
    'GOI',
    'FUK',
    'HKG',
    'HKT',
    'HND',
    'ICN',
    'KBV',
    'KIX',
    'NGO',
    'MEL',
    'NKG',
    'NRT',
    'OSA',
    'PEK',
    'PSA',
    'PUS',
    'PVG',
    'SEL',
    'SGN',
    'SHA',
    'SIN',
    'TLV',
    'TSE',
    'TYO',
    'VDA',
    'XIY',
  ],
  europe: [
    'ACE',
    'AGA',
    'AGP',
    'ALC',
    'ALF',
    'AMS',
    'ARN',
    'ATH',
    'AYT',
    'BCN',
    'BOO',
    'CDG',
    'BGO',
    'BER',
    'BIQ',
    'BLL',
    'BLQ',
    'BMA',
    'BRU',
    'BUD',
    'CFU',
    'CHQ',
    'CPH',
    'CTA',
    'DBV',
    'DLM',
    'DUB',
    'DUS',
    'EDI',
    'FAO',
    'FCO',
    'FLR',
    'FNC',
    'FRA',
    'FUE',
    'GDN',
    'GOJ',
    'GOT',
    'GVA',
    'GZP',
    'HAM',
    'HER',
    'IBZ',
    'INN',
    'JSI',
    'JTR',
    'KEF',
    'KGS',
    'KKN',
    'KRK',
    'KUF',
    'KZN',
    'LCA',
    'LED',
    'LIN',
    'LIS',
    'LHR',
    'LJU',
    'LON',
    'LLA',
    'LPA',
    'LUX',
    'KAZ',
    'MAD',
    'MAH',
    'MAN',
    'MIL',
    'MJT',
    'MLA',
    'MMX',
    'MOW',
    'MSQ',
    'MUC',
    'MXP',
    'NAP',
    'NCE',
    'NRK',
    'OPO',
    'OSL',
    'PAR',
    'PFO',
    'PMI',
    'PRG',
    'PUY',
    'PVK',
    'RHO',
    'RIX',
    'RMI',
    'ROM',
    'SKG',
    'SPU',
    'STO',
    'STR',
    'SVG',
    'SVO',
    'SVX',
    'SZG',
    'TAY',
    'TCI',
    'TFN',
    'TFS',
    'TIA',
    'TLL',
    'TOS',
    'TRD',
    'TRN',
    'TXL',
    'UME',
    'URE',
    'VAR',
    'VBY',
    'VCE',
    'VIE',
    'VLC',
    'VNO',
    'VRN',
    'WAW',
    // 'WRO',
    'ZAG',
    'ZRH',
    'ZTH',
  ],
  finland: ['ENF', 'HEL', 'IVL', 'JOE', 'JYV', 'KAJ', 'KEM', 'KOK', 'KTT', 'KUO', 'KAO', 'MHQ', 'OUL', 'RVN', 'TMP', 'TKU', 'VAA'],
};
